import { render, staticRenderFns } from "./ModalCadastroTipoOcorrencia.vue?vue&type=template&id=4db501c4"
import script from "./ModalCadastroTipoOcorrencia.vue?vue&type=script&lang=js"
export * from "./ModalCadastroTipoOcorrencia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports